module.exports = __webpack_public_path__ + "img/emb.4089908d.png";